'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "style", "start", "end"];
import * as React from 'react';
import { useRenderElement } from "../../base-ui-copy/utils/useRenderElement.mjs";
import { CalendarGridTimeEventPlaceholderCssVars } from "./CalendarGridTimeEventPlaceholderCssVars.mjs";
import { useCalendarGridTimeColumnContext } from "../time-column/CalendarGridTimeColumnContext.mjs";
import { useEvent } from "../../internals/utils/useEvent.mjs";
import { useElementPositionInCollection } from "../../internals/utils/useElementPositionInCollection.mjs";
export const CalendarGridTimeEventPlaceholder = /*#__PURE__*/React.forwardRef(function CalendarGridTimeEventPlaceholder(componentProps, forwardedRef) {
  const {
      // Rendering props

      // Internal props
      start,
      end
      // Props forwarded to the DOM element
    } = componentProps,
    elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);
  const {
    start: columnStart,
    end: columnEnd
  } = useCalendarGridTimeColumnContext();
  const {
    position,
    duration
  } = useElementPositionInCollection({
    start,
    end,
    collectionStart: columnStart,
    collectionEnd: columnEnd
  });
  const {
    state
  } = useEvent({
    start,
    end
  });
  return useRenderElement('div', componentProps, {
    state,
    ref: [forwardedRef],
    props: [elementProps, {
      style: {
        [CalendarGridTimeEventPlaceholderCssVars.yPosition]: `${position * 100}%`,
        [CalendarGridTimeEventPlaceholderCssVars.height]: `${duration * 100}%`
      }
    }]
  });
});
if (process.env.NODE_ENV !== "production") CalendarGridTimeEventPlaceholder.displayName = "CalendarGridTimeEventPlaceholder";